import React from 'react';
import classes from './BlockModal.module.css'
import { Link, useNavigate } from 'react-router-dom';

const BlockModalFree = ({onAccept,onDecline}) => {

    const navigate = useNavigate()

    const handleDecline=()=>{

    }

  return (
    <div className={classes.modal} >
       <div className={`cptpl_page ${classes.wrapper}`}>
   <input type="hidden" value="20221206" name="cptpl_template" class="cptpl_template"/>
   {/* <input type="hidden" value="20251023" name="cptpl_template" class="test cptpl_template" />  */}

      <input type="hidden" value="" name="cptpl_landing_page_id" class="test  cptpl_landing_page_id  " />

  <div className={classes.card}>
    <div className={classes.logoHeading}>
      <img src="https://vd-kickwin.gameit.in/assets/images/soccer-ball.png" alt="Logo" className={`cptpl_logo cptpl_logo_static  ${classes.logo}`}
     crossorigin="anonymous" />
      <h3 className={`cptpl_service ${classes.heading}`}>Kick n Winn</h3>
    </div>

    {/* <div className={classes.logoHeading}>
  <img
    src="/soccer-ball.png"
    alt="Logo"
    className={`cptpl_logo cptpl_logo_static ${classes.logo}`}
    crossOrigin="anonymous"
  />

  <h3 className={`cptpl_service ${classes.heading}`}>
    Kick n Winn
  </h3>
</div> */}

    

     <p className={classes.subtext}>
          <span>Get Endless Sports Insights with Kick n Winn</span><br/>
          <span className="cptpl_price" > Enjoy Your First-Day Free Trial at R7/Day After Trial</span><br />
          <span className="cptpl_account" >On Your Vodacom Account</span><br />
          <span className="cptpl_bill" >Pay with Vodacom Add To Bill</span>
          
        </p>
                  <Link className={` cptpl_terms ${classes.terms}`}>Terms & Conditions</Link>

          {/* <Link to='/terms' className={` cptpl_terms ${classes.terms}`}>Terms & Conditions</Link> */}
        <br/><br/>

    <div className={classes.block_content} >

    

    <p className={classes.subtext}>
Content Services are currently blocked for this number. If you select 'ACCEPT' you will be allowed to purchase this specific content, but other content services will remain blocked.

{/* Your Vodacom number currently has <strong>Content Block</strong> enabled.
<br/><br/>
        To continue with Kick n Winn service, please confirm your choice below.
  */}
     {/* This number is not eligible to purchase or subscribe to content services */}
    </p>

      <div className={classes.btns}>
      <button type="submit" className={`protected cptpl_subscribe ${classes.subbutton}`} onClick={onAccept}>
        ACCEPT
      </button>
      <button type="button" className={`protected cptpl_exit  ${classes.extbutton}`} onClick={onDecline}>
        DECLINE
      </button>
      </div>
      </div>

    
  </div>
</div>
   </div> 
  );
}

export default BlockModalFree;
